var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.774 16.899L11.917 1.184a2.143 2.143 0 00-3.834 0L.226 16.9A2.143 2.143 0 002.143 20h15.714a2.143 2.143 0 001.917-3.101zM8.93 7.143a1.071 1.071 0 012.142 0v4.286a1.071 1.071 0 01-2.142 0zm1.071 10a1.429 1.429 0 111.429-1.429A1.429 1.429 0 0110 17.143z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.81aa5d4f.svg";
export { ForwardRef as ReactComponent };